import {words} from "./words";

export class WordProvider {
    pool: string[];
    poolSize: number = 1000;

    constructor(poolSize= 1000) {
        this.pool = words;
        this.poolSize = poolSize;
    }

    getWords(count: number) {
        const selectedWords = [];
        for (let i = 0; i < count; i++) {
            const index = Math.floor(Math.random() * this.poolSize);
            selectedWords.push(this.pool[index]);
        }
        return selectedWords;
    }
}